/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum DropDownStyles {
    Default = '0',
    ChooseList = 1,
}
